import { SET_CONFIG } from '../actions/types';

const initialState = {
  loaded: false,
  features: {},
  towns: [],
  categories: [],
  tags: [],
};

export default function config(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CONFIG:
      return {
        loaded: true,
        features: action.payload?.features || {},
        towns: action.payload?.towns || [],
        categories: action.payload?.categories || [],
        tags: action.payload?.tags || [],
      };

    default:
      return state;
  }
}
